import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import UsersListPage from '../components/GuestListPage'
import {
  actionCreators,
  IGuestListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/guestList'

export default connect(
  createStructuredSelector<ApplicationState, IGuestListState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(UsersListPage)
